var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOrder = function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.63 16.45H7.673l.701-1.427 11.644-.02a.814.814 0 0 0 .801-.671l1.613-9.026a.815.815 0 0 0-.8-.958L6.82 4.298l-.126-.595a.833.833 0 0 0-.811-.656H2.262a.827.827 0 1 0 0 1.655h2.95l.553 2.63 1.362 6.592-1.753 2.862a.82.82 0 0 0-.07.862c.14.28.424.455.738.455h1.472a2.407 2.407 0 0 0 1.922 3.85 2.407 2.407 0 0 0 1.922-3.85h3.775a2.407 2.407 0 0 0 1.922 3.85 2.407 2.407 0 0 0 1.922-3.85h2.656c.454 0 .827-.37.827-.827a.83.83 0 0 0-.83-.825ZM7.165 5.93l13.495.044-1.322 7.402-10.6.019L7.164 5.93Zm2.27 14.36a.742.742 0 0 1-.74-.74c0-.409.333-.741.74-.741a.742.742 0 0 1 .524 1.264.74.74 0 0 1-.523.217Zm7.62 0a.742.742 0 0 1-.74-.74c0-.409.332-.741.74-.741a.742.742 0 0 1 .524 1.264.74.74 0 0 1-.524.217Z"
  })));
};

export default SvgOrder;